import * as React from "react";
import type { SVGProps } from "react";
const SvgEdit01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m12.537 19.243.742-.832a2.062 2.062 0 0 1 3.279.266 2.062 2.062 0 0 0 3.118.428l1.345-1.208M2.98 19.47l4.366-.88a1.2 1.2 0 0 0 .612-.328l9.773-9.779a1.2 1.2 0 0 0 0-1.697l-2.07-2.068a1.2 1.2 0 0 0-1.698 0l-9.774 9.78a1.2 1.2 0 0 0-.328.611z"
    />
  </svg>
);
export default SvgEdit01;
